import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=ef9d0f12&"
import script from "./UploadButton.vue?vue&type=script&lang=ts&"
export * from "./UploadButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports